module.exports = __webpack_public_path__ + "static/img/course_3.5b495c72.png";